export default {
  message: {
    title: 'Official Customer Service',
    dispute: {
      id: 'Dispute ID',
      createdAt: 'Initiation Time',
      orderDetails: 'Order Details',
      inArbitration: 'In Arbitration',
      serialNumber: 'Serial Number',
      orderNumber: 'Order Number',
      txnAmount: 'Total Amount',
      enableRefundAmount: 'Refundable Amount',
      holderEmail: 'Consumer Email',
      holderName: 'Consumer Name',
      txnTime: 'Order Date',
      txnWebsite: 'Transaction Website',
      productInfo: 'Products',
      endDispute: 'Close Dispute',
      applyArbitration: 'Apply For Arbitration',
      reset: 'Reset',
      send: 'Send',
      apply: 'Initiate Disputes',
      cardNoLast4: 'Last 4 Digits Of Card Number',
      type: 'Dispute Type',
      claims: 'Claims',
      claimsPlaceholder: 'Please enter the main reason for your dispute and the expected solution',
      nameHello: 'Dear {name}',
      orderInfo: 'You made a <span class="amount"> {currency} {amount} </span> purchase on <a href="{link}" target="_blank" class="website"> {website} </a> from <span class="date"> {date} </span>',
      tip: 'If you have any questions about this order, please enter and send dispute information',
      systemMessage: 'System messages',
      typeOptions: {
        unknow: 'Unknow',
        fraud: 'Fraud',
        unauthorized: 'Unauthorized',
        wrongGoods: 'Products Discrepancies',
        productNotReceived: 'Product Not Received',
        defectiveMerchandise: 'Defective Merchandise',
        incorrectTransaction: 'Incorrect Transaction',
        wrongAddress: 'Wrong address',
        creditNotProcessed: 'Credit Not Processed'
      },
      status: {
        0: 'In Coordination',
        1: 'In Arbitration',
        // 2: '已仲裁',去掉这个状态，不翻译
        3: 'Ended'
      },
      applyArbitrationSuccess: 'You have applied for arbitration',
      endDisputeSuccess: 'You have ended this dispute',
      comfirm: 'Submit',
      logisticsNumber: 'Tracking No'
    },
    checkout: {
      title: 'Sichere Zahlungsseite',
      description: 'Wir verschlüsseln Ihre Finanzinformationen sicher',
      methodErrorTips: 'Entschuldigung, das von Ihnen ausgewählte Land wird derzeit nicht unterstützt. Bitte wählen Sie ein anderes Land und versuchen Sie es erneut.',
      recommendation: 'Empfehlung',
      cardNumber: 'Kartennummer',
      cardName: 'Name auf der Karte',
      cvv: 'CVV',
      expiredDate: 'Ablaufdatum',
      billingInfo: 'Rechnungsinformationen',
      country: 'Land',
      state: 'Bundesland',
      firstName: 'Vorname',
      lastName: 'Nachname',
      document: 'Dokument',
      city: 'Stadt',
      address: 'Adresse',
      streetNumber: 'Straßennummer',
      zipCode: 'Postleitzahl',
      email: 'E-Mail',
      phone: 'Telefonnummer',
      pay: 'ZAHLEN',
      choosePaymentMethod: 'Zahlungsmethode wählen',
      continue: 'Fortsetzen',
      later: 'Später',
      returnToMerchant: 'Abbrechen und zum Händler zurückkehren',
      resultToMerchant: 'Zum Händler zurückkehren',
      orderId: 'Bestell-ID',
      orderAmount: 'Bestellbetrag',
      billingDescriptor: 'Rechnungsbezeichnung',
      goodsName: 'Produktname',
      timeLimit: 'Bitte schließen Sie die Zahlung innerhalb des Zeitlimits ab, andernfalls wird die Seite zeitlich überschritten',
      otherPaymentMethods: 'Andere Zahlungsmethoden',
      close: 'Schließen',
      paymentErrorTitle: 'Zahlung fehlgeschlagen',
      paymentErrorTip: 'Ihre Zahlung wurde nicht erfolgreich verarbeitet. Bitte versuchen Sie es erneut.',
      paymentFailed: 'Zahlungsvorgang fehlgeschlagen',
      continueShopping: 'Weiter einkaufen',
      paymentSuccess: 'Zahlung erfolgreich abgeschlossen',
      paymentPending: 'Zahlung gesendet, Bestätigung läuft',
      correctDateTip: 'Bitte geben Sie ein gültiges Ablaufdatum ein',
      correctCardNumberTip: 'Bitte geben Sie eine gültige Kartennummer ein',
      correctSecurityCodeTip: 'Bitte geben Sie einen gültigen Sicherheitscode ein',
      mobileMoneyOperator: 'Mobile GeldOperator',
      bank: 'Bank',
      correctEmailAddressTip: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      notSupportPaymentTip: 'Die aktuelle Umgebung unterstützt {type}-Zahlungen nicht',
      addValidPaymentCard: 'Bitte fügen Sie eine gültige Zahlungskarte hinzu',
      timeLimitTip: 'Die Gebühr wird 12 Stunden vor Ablauf der Testphase (<span class="date">{date}</span>) erhoben und verlängert sich danach alle <span class="date">{month}</span> Monate um <span class="amount"> {amount} {currency}</span>, kann jederzeit gekündigt werden',
      product: 'Produkt/Dienstleistung',
      subscribeType: 'Abonnementtyp',
      renewCycle: 'Verlängerungszyklus',
      renewAmount: 'Verlängerungsbetrag',
      subscribePay: 'Abonnieren und zahlen',
      readAgreement: "Lesen und akzeptieren Sie die <span class='protocol-link' style='color: #31a7da;'>„Automatische Verlängerungsvereinbarung“</span>",
      depict: 'Beschreibung',
      copyQrCode: 'QR-Code kopieren',
      copySuccess: 'QR-Code erfolgreich kopiert',
      copyError: 'QR-Code kopieren fehlgeschlagen',
      refreshQrCode: 'QR-Code aktualisieren'
    },
    subscribe: {
      yourSubscribe: 'Ihr Abonnement',
      unsubscribeTip: 'Um zu kündigen, klicken Sie auf die Schaltfläche [Abonnement kündigen] unten auf der Seite.',
      renewTip: 'Abbuchung von <span class="amount"> {amount} {currency}</span> am <span class="date">{date}</span>, jederzeit kündbar',
      unsubscribe: 'Abonnement kündigen',
      autoRenew: 'Automatische Verlängerungsvereinbarung',
      unsubscribeTipTwo: 'Wenn Sie jetzt kündigen, können Sie dieses Abonnement bis zum <span class="date">{date}</span> weiterhin nutzen.',
      emailVerifyTip: 'E-Mail-Verifizierung',
      inputCodeTip: 'Bitte geben Sie den Bestätigungscode ein',
      sendSuccessTip: 'Bestätigungscode erfolgreich gesendet',
      sendErrorTip: 'Bestätigungscode konnte nicht gesendet werden',
      unsubscribeSuccessTip: 'Abonnement erfolgreich gekündigt',
      unsubscribeErrorTip: 'Kündigung des Abonnements fehlgeschlagen',
      sendCodeTip: 'Erneut senden in {code} Sekunden',
      sendEmailTip: 'Bestätigungscode erhalten',
      daily: 'Alle Tage',
      weekly: 'Alle 7 Tage',
      monthly: 'Alle 30 Tage',
      quarterly: 'Alle 90 Tage',
      semiAnnually: 'Alle 180 Tage',
      annually: 'Alle 365 Tage',
      regularRenewal: 'Regelmäßige Verlängerung',
      oneTime: 'Einmalig',
      inputNumberTip: 'Bitte geben Sie nur Zahlen ein',
      eachCalendarMonth: 'Pro Kalendermonat'
    },
    common: {
      confirm: 'Bestätigen',
      cancel: 'Abbrechen',
      uploadImgErrorTip: 'Nur Bilder hochladen erlaubt',
      inputMessageTip: 'Bitte füllen Sie den Inhalt aus',
      sendSuccessTip: 'Senden erfolgreich',
      sendErrorTip: 'Senden fehlgeschlagen',
      inputPlaceholder: 'Bitte geben Sie {field} ein',
      selectPlaceholder: 'Bitte wählen Sie {field}',
      correctFormat: 'Bitte geben Sie das richtige Format ein, zum Beispiel: {example}'
    }
  }
}
